import { h } from '../../../utils/dom.js';
import { getLang, applyLanguage } from '../../../i18n/index.js';

export function LangSwitch() {
  const make = (code) => h('button', {
    class: code === getLang() ? 'active' : '',
    onclick: () => applyLanguage(code),
  }, code.toUpperCase());

  const el = h('div', { class: 'lang-switch' }, make('ar'), make('en'));
  return { el };
}